var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolarismediaLogoNeg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "polaris-media",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 88.1 88.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "p",
    className: "cls-1",
    d: "M67.6,54.5c0,4.1-2.2,5.4-5.4,5.4h-29.4l7.6-9.6h15.1c1.8,0,2.6-.6,2.6-2.6v-7.8c0-1.6-.4-2.6-2.6-2.6h-20.3c-1.9,0-2.6.8-2.6,2.6v20l-6.8,9.7s-1.7,2.7-3.6,2.2c-1-.2-1.7-1.1-1.7-2.1v-36.6c0-3.8,1.7-5.4,5.4-5.4h36.3c3.7,0,5.4,1.1,5.4,5.4v21.4ZM88.1,44C88.1,19.7,68.4,0,44.1,0S0,19.7,0,44s19.7,44,44,44h0c24.4,0,44.1-19.6,44.1-44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolarismediaLogoNeg);
export default __webpack_public_path__ + "static/media/polarismedia_logo_neg.4c63c55b7155262b0ebbd3a6f8616e86.svg";
export { ForwardRef as ReactComponent };